export default __webpack_public_path__ + "static/media/map4.a3eaf7b9.png";